import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WldConsentResponseStatus, WldDocumentSharingConsent, WldTermsContent } from '@interfaces';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WldTermsService {
  constructor(private http: HttpClient) {}

  getTermsContent(): Observable<WldTermsContent> {
    return this.http.get<WldTermsContent>('secure/documents/terms-conditions-text');
  }

  getDocumentSharingConsent(): Observable<WldDocumentSharingConsent> {
    return this.http.get<WldDocumentSharingConsent>('secure/documents/document-sharing-consent');
  }

  acceptDocumentSharingConsent(): Observable<WldDocumentSharingConsent> {
    return this.http.post<WldDocumentSharingConsent>('secure/documents/document-sharing-consent', {
      responseStatus: WldConsentResponseStatus.ACCEPT,
    });
  }
}
